import {
  FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS,
  FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED,
  FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED,
  FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS,
  FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED,
  FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED,
} from "constants/actionTypes";

const initState = {
  assetsMetrics: {
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
    loading: false,
    error: null,
  },
  datasourceMappingMetrics: {
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
    loading: false,
    error: null,
  },
};

function metricsReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS:
      return {
        ...state,
        assetsMetrics: {
          ...state.assetsMetrics,
          loading: true,
          error: null,
        },
      };

   case FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED: {
  const pagination = action.payload.pagination || {};
  const isFirstPage = (pagination.pageNumber ?? 0) === 0;
  return {
    ...state,
    assetsMetrics: {
      loading: false,
      items: isFirstPage
        ? action.payload.records
        : [...state.assetsMetrics.items, ...action.payload.records],
      pagination: {
        currentPage: pagination.pageNumber ?? 0,
        totalPages: pagination.totalPagesCount ?? 0,
        recordsPerPage: pagination.itemsPerPage ?? 20,
        totalRecordsCount: Number(pagination.totalItemCount) ?? 0,
      },
      error: null,
    },
  };
}

    case FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED:
      return {
        ...state,
        assetsMetrics: {
          ...state.assetsMetrics,
          loading: false,
          error: action.payload,
        },
      };

    case FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS:
      return {
        ...state,
        datasourceMappingMetrics: {
          ...state.datasourceMappingMetrics,
          loading: true,
          error: null,
        },
      };

    case FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED: {
  const pagination = action.payload.pagination || {};
  const isFirstPage = (pagination.pageNumber ?? 0) === 0;
  return {
    ...state,
    datasourceMappingMetrics: {
      loading: false,
      items: isFirstPage
        ? action.payload.records
        : [...state.datasourceMappingMetrics.items, ...action.payload.records],
      pagination: {
        currentPage: pagination.pageNumber ?? 0,
        totalPages: pagination.totalPagesCount ?? 0,
        recordsPerPage: pagination.itemsPerPage ?? 20,
        totalRecordsCount: Number(pagination.totalItemCount) ?? 0,
      },
      error: null,
    },
  };
}

    case FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED:
      return {
        ...state,
        datasourceMappingMetrics: {
          ...state.datasourceMappingMetrics,
          loading: false,
          error:
            action.payload?.errors?.[0]?.message || "Unknown error occurred",
        },
      };

    default:
      return state;
  }
}

export { metricsReducer };
